// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ylaos","checkboxCol":"Table_checkboxCol__2kE63","emailCol":"Table_emailCol__laaLL","actionCol":"Table_actionCol__2TFyi"};